import Block from "./Block";
import Button from "./Button";
import Divider from "./Divider";
import Image from "./Image";
import Map from "./Map";
import Organization from './Organization';
import Social from "./Social";
import Spacer from "./Spacer";
import Table from "./Table";
import Unsubscrible from './Unsubscrible';
import Video from "./Video";
import Html from "./Html";

export default {
  Block,
  Button,
  Divider,
  Image,
  Map,
  Organization,
  Social,
  Spacer,
  Table,
  Unsubscrible,
  Video,
  Html
};
